import { Injectable } from '@angular/core';
import { Config } from './config/config'
import { HttpClient } from '@angular/common/http'
import { StorageService } from './config/storage.service'

@Injectable({
  providedIn: 'root'
})
export class CommentService extends Config{

  constructor(
      private http:HttpClient,
      private storage:StorageService,
  ) { 
     super()
  }

  getComment(){
    let url = 'dashboard/get_comment'
    return this.http.get(this.BASE_URL_API + url,this.storage.getHeaders())
  }

  updateComment(item:any){
    let url = 'dashboard/update_comment'
    return this.http.post(this.BASE_URL_API + url,item,this.storage.getHeaders())
  }

  getCommentStatus(){
    let url = 'dashboard/get_comment_status'
    return this.http.get(this.BASE_URL_API + url,this.storage.getHeaders())
  }
 


}
